// Module
var code = "<p>Tutorial Page works !</p> ";
// Exports
export default code;